export const ProxiedElements = new WeakMap<Element, Element>();
